import type { StepWithArrowOffset } from 'shared/ui/joyride-tour/types'

export const createSearchParamsEditHintSteps = (
  content: string,
): StepWithArrowOffset[] => [
  {
    target: '#search-params-header',
    content,
    placement: 'bottom-end',
    disableBeacon: true,
    disableScrolling: true,
  },
]
